<template>
  <div id="pricing" class="col-12">
    <h3>Planos disponíveis para Todos os Times</h3>

    <p>Todos os planos incluem um <b>teste gratuito de 30 dias</b>.</p>

    <h5>Recursos disponíveis em todos os planos</h5>

    <div class="row col-12 justify-content-center">

      <div class="row col-8 p-0 justify-content-between service-images">

        <div class="task-image">
          <img src="https://bucket-tarserp-resources.s3-sa-east-1.amazonaws.com/images/tars-task.png" />
        </div>

        <div class="react-image">
          <img src="https://bucket-tarserp-resources.s3.sa-east-1.amazonaws.com/images/logo-react-color.webp" />
        </div>

        <div class="echo-image">
          <img src="https://bucket-tarserp-resources.s3.sa-east-1.amazonaws.com/images/logo-echo.webp" />
        </div>

        <div class="analyser-image">
          <img src="https://bucket-tarserp-resources.s3.sa-east-1.amazonaws.com/images/logo-analyser.webp" />
        </div>

        <div class="oneadmin-image">
          <img src="https://bucket-tarserp-resources.s3.sa-east-1.amazonaws.com/images/logo-oneadmin.webp" />
        </div>

      </div>

   </div>

    <div id="pricing-plans" class="row col-12">
      <div class="pricing-plan col-12 col-lg-4">
        <div class="billing">
          <div class="title">One Business</div>

          <div class="price">R$ 99,90</div>
          <div class="payment">Usuário / mês</div>
          <div class="taxes">R$ 89,90 no plano anual</div>

          <div class="start now">
            <router-link to="/signup/business/welcome">INICIAR AGORA</router-link>
          </div>
        </div>

        <div class="features">
          <h4>Características</h4>

          <ul>
            <li>Crie até <b>10 Automações no Task.</b></li>
            <li>Crie até <b>10 Formulários no React.</b></li>
            <li>Receba até <b>100 respostas nos formulários do React.</b></li>
            <li>Chat Integrado <b>Echo</b> para toda a equipe para conversas individuais</li>
            <li>Até <b>30 documentos</b> por mês no Analiser.</li>
            <li><b>10Gb</b> de armazenamento por usuário</li>
            <li>Conte com a implantação da TARS</li>
          </ul>
        </div>
        <p class="after-30-day"></p>
      </div>

      <div class="pricing-plan best-choice col-12 col-lg-4">
        <div class="billing">
          <div class="promo">Mais Popular!</div>
          <div class="title">One Plus</div>

          <div class="price">R$ 129,90</div>
          <div class="payment">Usuário / mês</div>
          <div class="taxes">R$ 109,90 no plano anual</div>

          <div class="start now">
            <router-link to="/signup/plus/welcome">INICIAR AGORA</router-link>
          </div>
        </div>

        <div class="features">
          <h4>Características</h4>

          <ul>
            <li>Crie automações <b>ilimitadas no Task</b>.</li>
            <li>Receba até <b>1.000 respostas</b> nos formulários do React.</li>
            <li>Formulários ilimitados.</li>
            <li>Chat integrado para toda equipe para conversas em <b>grupo e individuais.</b></li>
            <li>Até <b>100 documentos</b> por mês no Analiser.</li>
            <li><b>15Gb</b> de armazenamento por usuário (transferíveis).</li>
            <li>Conte com a implantação da TARS e importação de dados de outros sistemas.</li>
            <li>Conte com o suporte da TARS por telefone, whatsapp ou vídeo conferência.</li>
          </ul>
        </div>
      </div>

      <div class="pricing-plan col-12 col-lg-4">
        <div class="billing">
          <div class="title">One Pro</div>

          <div class="price">R$ 189,90</div>
          <div class="payment">Usuário / mês</div>
          <div class="taxes">R$ 159,90 no plano anual</div>

          <div class="start now">
            <router-link to="/signup/pro/welcome">INICIAR AGORA</router-link>
          </div>
        </div>

        <div class="features">
          <h4>Características</h4>

          <ul>
            <li>Receba até <b>10.000</b> respostas nos formulários do React</li>
            <li>Integre o Echo ao Whatsapp e envie até <b>1.000 mensagens</b>.</li>
            <li>Até <b>500 documentos</b> por mês no Analiser.</li>
            <li><b>20Gb</b> de armazenamento por usuário (transferíveis)</li>
            <li>Business Intelligence personalizada.</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 
        <div id="faq">

            <h5>FAQ de Preços e contratação</h5>

            <div class="question">
                <a v-on:click="evtOpenQuestion('q1')">
                    O que é um usuário?
                </a>
                <div class="answer" v-if="questionsOpened.indexOf('q1') > -1">
                    <span>
                        Um usuário é definido como um endereço de e-mail (você@suaempresa). 
                    </span>
                </div>
                
            </div>

            <div class="question">
                <a v-on:click="evtOpenQuestion('q2')">
                    Preciso de um cartão de crédito para iniciar?
                </a>
                <div class="answer" v-if="questionsOpened.indexOf('q2') > -1">
                    <span>
                        Resposta
                    </span>
                </div>
            </div>

            <div class="question">
                <a v-on:click="evtOpenQuestion('q3')">
                    Quanto custa uma licença do TARS One?
                </a>
                <div class="answer" v-if="questionsOpened.indexOf('q3') > -1">
                    <span>
                        Todos os preços por licença estão definidos 
                        acima na tabela de preços e planos.
                    </span>
                </div>
            </div>

            <div class="question">
                <a v-on:click="evtOpenQuestion('q4')">
                    Quais métodos de pagamentos são aceitos, e quais são os termos de pagamento?
                </a>
                <div class="answer" v-if="questionsOpened.indexOf('q4') > -1">
                    A TARS aceita os seguintes métodos de pagamentos:

                    <p>
                        <b>Cartão de crédito</b> - (MasterCard, Visa ou American Express) 
                        por meio do nosso <router-link to='/signup/business/welcome'>formulário de solicitação seguro.</router-link>

                        A cobrança por cartão de crédito é realizada de modo recorrente.
                    </p>

                    <p>
                        <b>Boleto bancário</b> - Por meio de ordem de serviço 
                        e contrato formalizado por um período de 12 meses.
                    </p>
                </div>
            </div>

            <div class="question">
                <a v-on:click="evtOpenQuestion('q5')">
                    O que é cobrança recorrente?
                </a>
                <div class="answer" v-if="questionsOpened.indexOf('q5') > -1">
                    <p>
                        A cobrança recorrente é uma forma rápida e eficaz de cobrança 
                        de mensalidade, pois é automatizado. funciona da seguinte forma:
                        você contrata o plano desejado, depois o valor é debitado todo mês
                        na data referente a data inicial da contratação.
                    </p>
                    
                    <p>
                        Além disso, um dos principais diferenciais é que se torna
                        possível pagar pelo cartão de crédito <b>sem bloquear o limite</b>.
                        Ou seja, você não precisa ter limite no cartão de crédito do valor total
                        do período em que deseja ter a conta do TARS One. Mas sim apenas da quantia
                        de cada mês.                        
                    </p>
                    
                </div>
            </div>

            <div class="question">
                <a v-on:click="evtOpenQuestion('q6')">
                    É realizada emissão de NFSe (Nota Fiscal de Serviço Eletrônica)?
                </a>
                <div class="answer" v-if="questionsOpened.indexOf('q6') > -1">
                    <p>
                       Sim. Após cada cobrança, nós enviamos no seu e-mail do usuário
                       principal, a Nota Fiscal de Serviço Eletrônica e a fatura
                       com os detalhes da cobrança 
                    </p>
                </div>
            </div>

            <div class="question">
                <a v-on:click="evtOpenQuestion('q7')">
                    Qual o município de geração das Notas Fiscais?
                </a>
                <div class="answer" v-if="questionsOpened.indexOf('q7') > -1">
                    <p>
                        A TARS fica localizada na cidade de Londrina no Paraná.
                        Portanto, a Nota Fiscal de Serviço é gerada utilizando Londrina
                        como cidade base.
                    </p>
                </div>
            </div>

    </div>-->
  </div>
</template>

<script>
export default {
  name: "pricing",
  data: function() {
    return {
      questionsOpened: []
    };
  },
  methods: {
    evtOpenQuestion(question) {
      var i = this.questionsOpened.indexOf(question);

      if (i > -1) this.questionsOpened.splice(i, 1);
      else this.questionsOpened.push(question);
    }
  }
};
</script>

<style lang="scss">
#pricing {
  max-width: 1200px;
  margin: 20px auto;

  h3 {
    text-align: center;
  }

  h5 {
    text-align: center;
  }

  p {
    text-align: center;
    font-size: 14px;
  }

  .service-images {
    text-align: center;
    margin-top: 20px;

    .task-image img {
      width: 100px;
    }

    .react-image img {
      width: 85px;
    }

    .echo-image img {
      width: 65px;
    }

    .analyser-image img {
      margin-top: 5px;
      width: 150px;
    }

    .oneadmin-image img {
      margin-top: 5px;
      width: 200px;
    }

  }

  #pricing-plans {
    display: flex;
    margin: 40px 15px;

    .best-choice {
      border: 1px solid #25b686;
    }

    .pricing-plan {
      flex: 1;

      .billing {
        border-bottom: 1px solid #ddd;
        padding: 20px;
        margin: 20px;
        text-align: center;

        div {
          margin-bottom: 5px;
          text-align: left;
        }

        .promo {
            text-align: center;
            height: 55px;
            line-height: 55px;
            width: 90px;
            position: absolute;
            left: -45px;
            top: 11px;
            font-size: 12px;
            font-weight: 450;
            color: #fff;
            background-color: rgb(36, 192, 116);
            border-radius: 3px;
        }
        .title {
          font-weight: 500;
        }

        .price {
          font-size: 36px;
          font-weight: 300;
        }

        .paymet {
          font-size: 14px;
        }

        .taxes {
          font-size: 12px;
        }

        .start {
          border-radius: 3px;
          transition: background-color 0.2s;
          cursor: pointer;
          margin-top: 10px;
          text-align: center;
          font-size: 13px;

          a {
            text-decoration: none;
          }
        }

        .now {
          background-color: #25b686;
          color: #fff;
          padding: 10px 30px;
          border: none;

          a {
            color: #fff;
          }
        }

        .now:hover {
          background-color: #108f65;
        }

        .soon {
          background-color: #fff;
          padding: 8px 28px;
          border: 2px solid #25b686;

          a {
            color: #25b686;
          }
        }

        .soon:hover {
          background-color: #eee;
        }
      }

      .features {
        padding: 0 20px;
        margin: 0 20px;

        li {
          margin-left: 20px;
          text-align: left;
          font-size: 14px;
          color: #666;
          margin-bottom: 10px;
        }        
      }

      .after-30-day {
        font-size: 12px; 
        text-align:left;
        padding: 20px;
        margin: 20px;
      }
    }
  }

  #faq {
    h5 {
      padding-left: 10px;
      margin-bottom: 20px;
    }

    font-size: 14px;

    .question {
      margin: 10px 0 20px 0;

      .answer {
        background-color: #ecf0f1;
        padding: 10px;
        border-radius: 5px;

        p {
          text-align: left;
          margin: 10px 0;
        }
      }
    }

    a {
      cursor: pointer;
      transition: color 0.2s;
      padding-left: 10px;
    }

    a:hover {
      color: #25b686;
    }
  }
}
</style>